import * as React from 'react'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import useOverlimitEmployeesChecker from 'modules/employees/components/OverlimitEmployees/useOverlimitEmployeesChecker'
import AnnouncementBanner from 'modules/onboarding/components/AnnouncementBanner'

const OverlimitEmployeesBanner = () => {
  const { currentSeats, limitEmployeesCurrentPlan } = useOverlimitEmployeesChecker()

  const notification = i18n.t('overlimit_employees_banner.message', {
    currentSeats,
    limitEmployeesCurrentPlan,
  })

  return <AnnouncementBanner notification={notification} />
}

export default observer(OverlimitEmployeesBanner)
